import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import HorizontalLogo from '@app/assets/horizontal-logo.svg?react';

export const ComingSoon = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex justify-center mb-8">
          <HorizontalLogo width={200} height={88} />
        </div>
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          {t('comingSoon.title', 'Coming Soon')}
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
          {t('comingSoon.description', 'We\'re working hard to bring you this amazing feature. Stay tuned for updates!')}
        </p>
        <Link 
          to="/" 
          className="inline-block bg-brand-baseBlue text-white px-6 py-3 rounded-lg font-medium hover:bg-brand-darkBlue1 transition-colors"
        >
          {t('comingSoon.backToHome', 'Back to Home')}
        </Link>
      </div>
    </div>
  );
}; 